// Generated by Claude Code
import { createIcon } from '#components/primitives/icons/create-icon.ts'

const Close = createIcon(
  'close',
  {
    line: [
      'M6 6L18 18M18 6L6 18',
    ],
    fill: [
      'M12 10.586L17.293 5.293C17.683 4.902 18.317 4.902 18.707 5.293C19.098 5.683 19.098 6.317 18.707 6.707L13.414 12L18.707 17.293C19.098 17.683 19.098 18.317 18.707 18.707C18.317 19.098 17.683 19.098 17.293 18.707L12 13.414L6.707 18.707C6.317 19.098 5.683 19.098 5.293 18.707C4.902 18.317 4.902 17.683 5.293 17.293L10.586 12L5.293 6.707C4.902 6.317 4.902 5.683 5.293 5.293C5.683 4.902 6.317 4.902 6.707 5.293Z',
    ],
  },
)

export default Close
